export interface PageEventListener {
  onShowPreviewHeader(): void

  onHidePreviewHeader(): void
}

class PreviewWindowManager {
  #pageListener: PageEventListener | undefined

  setListener(listener: PageEventListener): void {
    this.#pageListener = listener
  }

  showPreviewHeader() {
    this.#pageListener?.onShowPreviewHeader()
  }

  hidePreviewHeader() {
    this.#pageListener?.onHidePreviewHeader()
  }
}
const INSTANCE = new PreviewWindowManager()

export { INSTANCE }
